import type { CustomerStore } from '@stores/me/customer/interfaces'

export const _setCustomer = (state: CustomerStore, customer: CustomerStore['customer']): void => {
  state.customer = customer
  state.updatedAt = customer ? Date.now() : 0
  state.status = customer ? 'ready' : 'idle'
}
